<template>
    <div>
        <div class="container-fluid">
            <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''">
            </div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
            <div class="row">
                <div class="col-12" v-html="content">
                    <!--div class="content-pages" v-if="this.$root.store === 1">
                        <h2 class="page-title">FAQ's</h2>
                        <h3>How do I place an order?</h3>
                        <ul>
                            <li> Select the size of the product you wish to buy</li>
                            <li> Add the product to your shopping bag by clicking on "Add to Bag"</li>
                            <li> Go to your shopping bag and click on "Go to Checkout"</li>
                            <li> Provide your Shipping and Billing Address - Select the payment method by clicking on
                                "Prepaid" or "Cash on Delivery"</li>
                            <li> Confirm payment and your order will be placed</li>
                        </ul>
                        <h3>Do I need to create an account to place an order? </h3>
                        <p>No, it's not necessary to create an account if you wish to place an order. You can simply
                            provide your shipping and billing details, select the payment method and place an order.</p>
                        <h3>Why have I not received my order yet?</h3>
                        <p>In rare situations, orders may get delayed due to courier or shipment issues. We will keep
                            you updated through calls or emails on the status of your orders. You can also call or email
                            us to check on your orders.</p>

                        <h3>Do I need to pay any delivery or courier charges for my order?</h3>
                        <p>No, there is no courier or delivery charge applicable on your orders. We have free shipping
                            for all orders placed on www.wforwoman.com.</p>

                        <h3>How can I track my order? </h3>
                        <p>We will send you tracking details once your order is shipped from our warehouse. You can go
                            to the courier partner's website and track your order with the AWB no.</p>

                        <h3>How do I return my product? </h3>
                        <p>If you are not happy with your purchase, you can just call or email us within 30 days of
                            delivery and we will arrange a return for your order
                        </p>
                        <h3>How soon can I receive the refund of my order?</h3>
                        <p>We will initiate refund once your product returns to our warehouse and the quality check is
                            done. It usually takes up to 4-5 business days for prepaid and 5-7 business days for COD
                            order to reflect the amount to your bank account.</p>

                        <h3>How do I cancel my order?</h3>
                        <p>Just call or email us with the reason of cancellation and we will cancel the order for you.
                            If your order has been already shipped then cancellation will not be possible. You can
                            refuse to take the delivery and your order will be cancelled automatically.
                        </p>
                        <h3>My order was COD, how will I get my refund amount?</h3>
                        <p>We will send you an email asking for your bank account details once we receive the product at
                            our warehouse. You will receive the amount to your bank account within 5 to 7 business days
                            once the refund is initiated.</p>

                        <h3>How can I figure out the correct size for me?</h3>
                        <p>You can refer to our size chart which is available on the product page above "Go to Bag"
                            button.
                        </p>
                        <h3>Size is not available now, how long do I need to wait?</h3>
                        <p>We cannot provide any specific timeline for the availability of the size. You can add the
                            product to your wishlist by clicking on the button next to "Add to Bag". We will notify you
                            whenever the size is available in future.</p>

                        <h3>How do I pay for my order?</h3>
                        <p>There are multiples ways you can pay for your order
                        </p>
                        <ul>
                            <li>Cash On Delivery</li>
                            <li>Credit Card</li>
                            <li>Debit Card</li>
                            <li>Net Banking</li>
                            <li>PayU Money</li>
                            <li>EMI</li>
                            <li>Wallets like Airtel, FreeCharge, Ola Money, Oxigen and YesPay</li>
                        </ul>
                        <h3>Is it safe to place an order with my credit/debit card?</h3>
                        <p>Yes, all our payments are secured by PayU money. Any details provided by you during
                            transaction are completely safe with us. Please refer to our Privacy Policy to know more.
                        </p>

                        <h3>There was a payment failure while placing my order, what should I do?</h3>
                        <p>If the amount has been deducted from your back account then we would request you to wait for
                            24 hours as it's usually credited back to your account. If you do not receive the amount
                            within 24 hours, call or email us with your bank account statement and we will help you
                            further.</p>

                        <h3>Can I get my order delivered to multiple addresses?</h3>
                        <p>Your order can be delivered to only one address. If you wish to send products to several
                            addresses, please place separate orders for each address.</p>

                        <h3>Do you ship internationally?</h3>
                        <p>No, currently we do not have the facility to ship products internationally.</p>

                        <h3>Delivery is not available on my address, what should I do?</h3>
                        <p>We would request you to check again after some days as we are trying to add more pin codes to
                            our deliverable address list.</p>
                        <h3>How do I return my order?</h3>
                        <p>Normally we arrange a reverse pickup for every return. However at times we are unable to do
                            so due to unavoidable issues. In that case, you can return your order through courier.
                            Refundable amount for self-shipping is Rs 100 only. </p>
                        <h3>How can I purchase E-Vouchers?</h3>
                        <p>Go to wforwoman.com or click here. Offer Vouchers can be purchased in prepaid mode only.
                            Customers can use credit card/debit card/net banking to make payment. Cash on delivery
                            option is not available for Offer vouchers</p>
                        <h3>I just received an E- Voucher. How do I use it?</h3>
                        <p>Go to wforwoman.com or W exclusive store to purchase. You can use them by placing orders by
                            selecting Offer Vouchers options. You can also give it to the W store manager at the time of
                            billing in stores.</p>
                        <h3>What should I do if I have not received the e-mail that had E-Voucher details?</h3>
                        <p>The E-Voucher email & SMS is typically sent to the recipient within 24 hours of your
                            purchase. If E- Voucher has not arrived within a reasonable time-frame please ensure that
                            recipient checks e-mail'Spam/Junk' inbox before contacting customer support.</p>
                        <h3>Does E- Vouchers expire?</h3>
                        <p>Yes, E- Voucher expires in 365 days from the date of issue.</p>
                        <h3>When is the E- Voucher issued / sent to the recipient?</h3>
                        <p>The E-Voucher SMS/Email is typically sent to the recipient within 24 hours of your purchase.
                            If E- Voucher has not arrived within a reasonable time-frame please ensure that recipient
                            checks e-mail'Spam/Junk' inbox before contacting Customer Support Team.</p>
                        <h3>How do I cancel a E-Voucher?</h3>
                        <p>This E-Voucher cannot be cancelled, refunded, or returned.</p>
                        <h3>What happens if I need to return something I purchased with my EVoucher?</h3>
                        <p>In cases where the website order is cancelled/refunded, the E-Voucher shall be reissued to
                            the customer. The E-Voucher amount shall not be refunded to the user. (Applicable on Website
                            voucher only)</p>
                        <p>In case of store voucher, store orders cannot be returned. Customer can exchange products on
                            MRP to MRP value as per the store exchange policies. E- Offer Voucher shall not be reissued
                            to the customer. </p>
                        <h3>How many E-Vouchers can be used in one transaction?</h3>
                        <p>Only one E-Voucher can be used in a single transaction. Multiple E- Offer Vouchers cannot be
                            clubbed in a single order. </p>
                        <h3>How many times E-Vouchers can be used?</h3>
                        <p>Each E-Voucher can be used in single transaction only. E-Voucher cannot be used partially in
                            multiple transactions. </p>
                    </div>

                    <div class="content-pages" v-else>
                        <h2 class="page-title">FAQ's</h2>
                        <h3>How do I place an order?</h3>
                        <ul>
                            <li>Select the size of the product you wish to buy</li>
                            <li>Add the product to your shopping bag by clicking on “Add to Bag”</li>
                            <li>Go to your shopping bag and click on “Go to Checkout”</li>
                            <li>Provide your Shipping and Billing Address</li>
                            <li>Select the payment method by clicking on “Prepaid” or “Cash on Delivery”</li>
                            <li>Confirm payment and your order will be placed</li>
                        </ul>
                        <h3>Do I need to create an account to place an order?</h3>
                        <p>No, it’s not necessary to create an account if you wish to place an order. You can simply
                            provide your shipping and billing details, select the payment method and place an order.</p>
                        <h3>Why have I not received my order yet?</h3>
                        <p>In rare situations, orders may get delayed due to courier or shipment issues. We will keep
                            you updated through calls or emails on the status of your orders. You can also call or email
                            us to check on your orders.</p>
                        <h3>Do I need to pay any delivery or courier charges for my order?</h3>
                        <p>No, there is no courier or delivery charge applicable on your orders. We have free shipping
                            for all orders placed on www.shopforaurelia.com.</p>
                        <h3>How can I track my order? </h3>
                        <p>We will send you tracking details once your order is shipped from our warehouse. You can go
                            to the courier partner’s website and track your order with the AWB no.</p>
                        <h3>How do I return my product? </h3>
                        <p>If you are not happy with your purchase, you can just call or email us within 30 days of
                            delivery and we will arrange a return for your order</p>
                        <h3>How soon can I receive the refund of my order?</h3>
                        <p>We will initiate refund once your product returns to our warehouse and the quality check is
                            done. It usually takes up to 4-5 business days for prepaid and 5-7 business days for COD
                            order to reflect the amount to your bank account.</p>
                        <h3>How do I cancel my order?</h3>
                        <p>Just call or email us with the reason of cancellation and we will cancel the order for you.
                            If your order has been already shipped then cancellation will not be possible. You can
                            refuse to take the delivery and your order will be cancelled automatically.</p>
                        <h3>My order was COD, how will I get my refund amount?</h3>
                        <p>We will send you an email asking for your bank account details once we receive the product at
                            our warehouse. You will receive the amount to your bank account within 5 to 7 business days
                            once the refund is initiated.</p>
                        <h3>How can I figure out the correct size for me?</h3>
                        <p>You can refer to our size chart which is available on the product page above “Go to Bag”
                            button.</p>
                        <h3>Size is not available now, how long do I need to wait?</h3>
                        <p>We cannot provide any specific timeline for the availability of the size. You can add the
                            product to your wishlist by clicking on the button next to “Add to Bag”. We will notify you
                            whenever the size is available in future.</p>
                        <h3>How do I pay for my order?</h3>
                        <p>There are multiples ways you can pay for your order</p>
                        <ul>
                            <li>Cash On Delivery</li>
                            <li>Credit Card</li>
                            <li>Debit Card</li>
                            <li>Net Banking</li>
                            <li>PayU Money</li>
                            <li>EMI</li>
                            <li>Wallets like Airtel, FreeCharge, Ola Money, Oxigen and YesPay</li>
                        </ul>
                        <h3>Is it safe to place an order with my credit/debit card?</h3>
                        <p>Yes, all our payments are secured by PayU money. Any details provided by you during
                            transaction are completely safe with us. Please refer to our Privacy Policy to know more.
                        </p>
                        <h3>There was a payment failure while placing my order, what should I do?</h3>
                        <p>If the amount has been deducted from your back account then we would request you to wait for
                            24 hours as it’s usually credited back to your account. If you do not receive the amount
                            within 24 hours, call or email us with your bank account statement and we will help you
                            further.</p>
                        <h3>Can I get my order delivered to multiple addresses?</h3>
                        <p>Your order can be delivered to only one address. If you wish to send products to several
                            addresses, please place separate orders for each address.</p>
                        <h3>Do you ship internationally?</h3>
                        <p>No, currently we do not have the facility to ship products internationally.</p>
                        <h3>Delivery is not available on my address, what should I do?</h3>
                        <p>We would request you to check again after some days as we are trying to add more pin codes to
                            our deliverable address list.</p>
                        <h3>How do I return my order?</h3>
                        <p>Normally we arrange a reverse pickup for every return. However at times we are unable to do
                            so due to unavoidable issues. In that case, you can return your order through courier.
                            Refundable amount for self-shipping is Rs 100 only. </p>
                        <h3>How can I purchase E-Vouchers?</h3>
                        <p>Go to ShopforAurelia.com or click here. Offer Vouchers can be purchased in prepaid mode only.
                            Customers can
                            use Credit Card/Debit Card/Net Banking to make payment. Cash on Delivery option is not
                            available for Offer
                            vouchers</p>
                        <h3>I just received an E- Voucher. How do I use it?</h3>
                        <p>Go to ShopforAurelia.com/Aurelia exclusive store to purchase. You can use them by placing
                            orders by selecting
                            Offer Vouchers options. You can also give it to the Aurelia store manager at the time of
                            billing in stores.</p>
                        <h3>What should I do if I have not received the e-mail that had E-Voucher details?</h3>
                        <p>The E-Voucher email &amp; SMS is typically sent to the recipient within 24 hours of your
                            purchase. If E- Voucher
                            has not arrived within a reasonable time-frame please ensure that recipient checks
                            e-mail&#39;Spam/Junk&#39; inbox
                            before contacting customer support.</p>
                        <h3>Does E- Vouchers expire?</h3>
                        <p>Yes, E- Voucher expires in 365 days from the date of issue.</p>
                        <h3>When is the E- Voucher issued / sent to the recipient?</h3>
                        <p>The E-Voucher SMS/Email is typically sent to the recipient within 24 hours of your purchase.
                            If E- Voucher has
                            not arrived within a reasonable time-frame please ensure that recipient checks
                            e-mail&#39;Spam/Junk&#39; inbox
                            before contacting Customer Support Team.</p>
                        <h3>How do I cancel a E-Voucher?</h3>
                        <p>This E-Voucher cannot be cancelled, refunded, or returned.</p>
                        <h3>What happens if I need to return something I purchased with my EVoucher?</h3>
                        <p>In cases where the website order is cancelled/refunded, the E-Voucher shall be reissued to
                            the customer. The
                            E-Voucher amount shall not be refunded to the user. (Applicable on Website voucher only)
                            </br>
                            In case of store voucher, store orders cannot be returned. Customer can exchange products on
                            MRP to MRP
                            value as per the store exchange policies. E- Offer Voucher shall not be reissued to the
                            customer.</p>
                        <h3>How many E-Vouchers can be used in one transaction?</h3>
                        <p>Only one E-Voucher can be used in a single transaction. Multiple E- Offer Vouchers cannot be
                            clubbed in a
                            single order.</p>
                        <h3>How many times E-Vouchers can be used?</h3>
                        <p>Each E-Voucher can be used in single transaction only. E-Voucher cannot be used partially in
                            multiple
                            transactions.</p>
                    </div-->
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'support',
        metaInfo() {
            return {
                title: this.meta_title,
                meta: [
                    {
                        name: 'description',
                        content: this.meta_description
                    },
                    {
                        property: 'keywords',
                        content: this.meta_keyword
                    }
                ]
            }
        },
        data() {
            return {
                meta_title: '',
                meta_description: '',
                meta_keyword: '',
                content:''
            };
        },
        beforeMount() {
            this.$root.page_loader = true;
            axios.get(this.$root.api_url+`/pim/pimresponse.php?service=cms_page&url_key=faqs&store=${this.$root.store}`)
            .then(response => {
                this.$root.page_loader = false;
                if(response.data.response.success==1){
                    this.$root.breadcrumb = response.data.result[0].name;
                    this.$root.page_loader = false;
                    this.content=response.data.result[0].content;
                    this.meta_title = response.data.result[0].meta_title;
                    this.meta_description = response.data.result[0].meta_description;
                    this.meta_keyword = '';
                }
                else
                {
                    this.$router.push('/404');
                }
            }).catch(error=>{
                this.$root.page_loader = false;
            })
        },
        created() {
            window.scrollTo(0, 0);
            // this.$root.breadcrumb = 'Support';
            // if (this.$root.store === 1) {
            //     this.meta_title = 'FAQ - W For Woman';
            //     this.meta_description = 'FAQ - W For Woman';
            //     this.meta_keyword = 'FAQ';
            // }
            // else {
            //     this.meta_title = 'FAQ - Aurelia';
            //     this.meta_description = 'FAQ - Aurelia';
            //     this.meta_keyword = 'FAQ';
            // }
        }
    }
</script>